export default __webpack_public_path__ + "static/media/about-pintar-new.43bbb81c.webp";